import { render, staticRenderFns } from "./veStuReservation.vue?vue&type=template&id=72dc2084&scoped=true"
import script from "./veStuReservation.vue?vue&type=script&lang=js"
export * from "./veStuReservation.vue?vue&type=script&lang=js"
import style0 from "./veStuReservation.vue?vue&type=style&index=0&id=72dc2084&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc2084",
  null
  
)

export default component.exports